import React, { useMemo } from 'react';
import { Text } from '../../../../design-system';
import { useTranslation } from 'react-i18next';
import { FilterOption } from '../../../types';
import { ExposedFiltersTypes, FilterTypes } from '../../../constants/initialFilters';
import CheckboxSelector from '../../CheckboxComponent';
import { Disclaimer } from '../Filters.style';
import { OfferTypeListWrapper, CheckBoxContainer } from '../OfferType/OfferType.styles';
import FilterSection from '../FilterSection';

interface OfferRegionProps {
  filterType: string;
  offerRegionOptions: {
    [key: string]: FilterOption;
  };
  confirmedFilters: FilterTypes;
  availableFilters: string[];
  openedFiltersList: ExposedFiltersTypes;
  handleAddFilter: (filterType: string, value: string, isChecked?: boolean) => void;
  handleExposeFilter: (arg: string) => void;
}

const OfferRegion: React.FC<OfferRegionProps> = ({
  filterType,
  offerRegionOptions,
  confirmedFilters,
  handleAddFilter,
  handleExposeFilter,
  openedFiltersList,
  availableFilters,
}) => {
  const { t } = useTranslation();

  const selectedOfferTypesList = useMemo(() => {
    const seletedOfferTypeOptions = confirmedFilters.offerRegion;
    return seletedOfferTypeOptions
      .map((offerRegion) => offerRegionOptions[offerRegion].label)
      .join(', ');
  }, [confirmedFilters.offerRegion, offerRegionOptions]);

  const selectedOfferTypes = useMemo(() => {
    return confirmedFilters.offerRegion;
  }, [confirmedFilters.offerRegion]);

  const handleAddOfferTypeFilter = (value: string, isChecked?: boolean) => {
    handleAddFilter(filterType, value, isChecked);
  };

  const offerRegionOffersList = Object.keys(offerRegionOptions).filter(
    (toCheck) => !offerRegionOptions[toCheck].shouldHide,
  );

  return (
    <FilterSection
      filterType={filterType}
      selectedFilterLabels={selectedOfferTypesList}
      openedFiltersList={openedFiltersList}
      handleExposeFilter={handleExposeFilter}
      testId="filter-offerRegion"
    >
      <Disclaimer>
        <Text
          variant={{
            order: '2',
            style: 'normal',
          }}
        >
          {t('promo.filters.filterOptions.offerRegion.description')}
        </Text>
      </Disclaimer>
      <OfferTypeListWrapper data-testid="offerType-list">
        {offerRegionOffersList.map((filterOption) => {
          const option = offerRegionOptions[filterOption];
          return (
            <CheckBoxContainer key={filterOption}>
              <CheckboxSelector
                inputName={option.value}
                key={option.value}
                onChange={() =>
                  handleAddOfferTypeFilter(option.value, selectedOfferTypes.includes(option.value))
                }
                value={option.value}
                label={option.label}
                ariaLabel={option.ariaLabel}
                checked={selectedOfferTypes.includes(option.value)}
                disabled={!availableFilters.includes(option.value)}
                hint={option.hint}
                filterType={filterType}
              />
            </CheckBoxContainer>
          );
        })}
      </OfferTypeListWrapper>
    </FilterSection>
  );
};

export default OfferRegion;
